import { TFunction } from "i18next";
import { SecondaryColor } from "node-library/dist/colors";
import {
	AdditionalInfoFieldType,
	FrontendTurnaroundTimeOptions,
	MicroTestMethod,
	ReceivingCondition,
	TurnaroundTime,
} from "node-library/dist/constants";
import {
	FrontendSampleAdditionalInfoMapping,
	FrontendSampleInstanceAdditionalInfoMapping,
	FrontendSampleTestInformation,
} from "node-library/dist/portal";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { SampleSortColumn } from "node-library/dist/paginations";

export function TurnaroundTimeToTATOption(
	turnaroundTime: TurnaroundTime
): FrontendTurnaroundTimeOptions {
	switch (turnaroundTime) {
		case TurnaroundTime.STANDARD:
			return FrontendTurnaroundTimeOptions.STANDARD;
		case TurnaroundTime.RUSH:
			return FrontendTurnaroundTimeOptions.RUSH;
		case TurnaroundTime.URGENT:
			return FrontendTurnaroundTimeOptions.URGENT;
		case TurnaroundTime.SAMEDAY:
			return FrontendTurnaroundTimeOptions.SAMEDAY;
	}
}
export function TATOptionToTurnaroundTime(
	TATOption: FrontendTurnaroundTimeOptions
): TurnaroundTime {
	switch (TATOption) {
		case FrontendTurnaroundTimeOptions.STANDARD:
			return TurnaroundTime.STANDARD;
		case FrontendTurnaroundTimeOptions.RUSH:
			return TurnaroundTime.RUSH;
		case FrontendTurnaroundTimeOptions.URGENT:
			return TurnaroundTime.URGENT;
		case FrontendTurnaroundTimeOptions.SAMEDAY:
			return TurnaroundTime.SAMEDAY;
		default:
			return TurnaroundTime.STANDARD;
	}
}

// export function getBasicTestTranslationFromKey(
// 	key: keyof TestingOptionsBase,
// 	translation: TFunction<"translation", undefined>
// ): string {
// 	switch (key) {
// 		case "cannabinoid":
// 			return translation("CannabinoidPotency");
// 		case "terpene":
// 			return translation("Terpene");
// 		case "pesticides":
// 			return translation("Pesticides");
// 		case "mycotoxins":
// 			return translation("Mycotoxins");
// 		case "heavyMetals":
// 			return translation("HeavyMetal");
// 		case "foreignMatter":
// 			return translation("ForeignMatter");
// 		case "moistureContent":
// 			return translation("MoistureContent");
// 		case "residualSolvent":
// 			return translation("ResidualSolvent");
// 		case "waterActivity":
// 			return translation("WaterActivity");
// 	}
// }

// export function getMicroTestTranslationFromKey(
// 	key: keyof MicroTestingOptions,
// 	translation: TFunction<"translation", undefined>
// ): string {
// 	switch (key) {
// 		case "TAMC":
// 			return translation("TAMC");
// 		case "TYMC":
// 			return translation("TYMC");
// 		case "BTGN":
// 			return translation("BTGN");
// 		case "Salmonella":
// 			return translation("Salmonella");
// 		case "EColi":
// 			return translation("EColi");
// 		case "Staphylococcus":
// 			return translation("Staphylococcus");
// 		case "Pseudomonas":
// 			return translation("Pseudomonas");
// 		case "viroids":
// 			return translation("Viroids");
// 		case "sexGenderTesting":
// 			return translation("SexGenderTesting");
// 	}
// }

export function getShortTurnaroundTime(
	time: TurnaroundTime,
	translation: TFunction<"translation", undefined>
): string {
	switch (time) {
		case TurnaroundTime.STANDARD:
			return translation("Standard");
		case TurnaroundTime.RUSH:
			return translation("Rush");
		case TurnaroundTime.URGENT:
			return translation("Urgent");
		case TurnaroundTime.SAMEDAY:
			return translation("SameDay");
	}
}
export function getReceivingConditionTranslationText(
	condition: ReceivingCondition,
	translation: TFunction<"translation", undefined>
): string {
	switch (condition) {
		case ReceivingCondition.AMBIENT:
			return translation("Ambient");
		case ReceivingCondition.IN_COOLER:
			return translation("InCooler");
		case ReceivingCondition.OTHER:
			return translation("Other");
	}
}

function areNestedObjectsEqual(objA: any, objB: any): boolean {
	if (objA == objB) return true; // Same reference or both null/undefined

	for (const key in objA) {
		if (objA[key] != objB[key]) {
			return false; // Return false if any property is not equal
		}
	}
	return true; // All nested properties are equal
}

export function getTurnaroundTimeBackgroundColor(
	turnaroundTime: TurnaroundTime
): string {
	switch (turnaroundTime) {
		case TurnaroundTime.STANDARD:
			return SecondaryColor.SECONDARY_100;
		case TurnaroundTime.RUSH:
			return SecondaryColor.SECONDARY_200;
		case TurnaroundTime.URGENT:
			return SecondaryColor.SECONDARY_400;
		case TurnaroundTime.SAMEDAY:
			return SecondaryColor.SECONDARY_600;
	}
}

// export function getMatrixTranslationText(
// 	matrix: SampleMatrix,
// 	translation: TFunction<"translation", undefined>
// ): string {
// 	switch (matrix) {
// 		case SampleMatrix.DRIED_CANNABIS:
// 			return translation("DRIED_CANNABIS");
// 		case SampleMatrix.HEMP:
// 			return translation("HEMP");

// 		case SampleMatrix.FRESH_CANNABIS:
// 			return translation("FRESH_CANNABIS");

// 		case SampleMatrix.CONSUMABLES:
// 			return translation("CONSUMABLES");

// 		case SampleMatrix.TOPICALS:
// 			return translation("TOPICALS");

// 		case SampleMatrix.CHEMICAL_CONCENTRATE_EXTRACT:
// 			return translation("CHEMICAL_CONCENTRATE_EXTRACT");

// 		case SampleMatrix.PHYSICAL_CONCENTRATE_EXTRACT:
// 			return translation("PHYSICAL_CONCENTRATE_EXTRACT");

// 		case SampleMatrix.ACCESSORIES:
// 			return translation("ACCESSORIES");

// 		case SampleMatrix.OTHER:
// 			return translation("OTHER");
// 	}
// }

// export function getSubMatrixTranslationText(
// 	subMatrix: SampleSubMatrix,
// 	translation: TFunction<"translation", undefined>
// ): string {
// 	switch (subMatrix) {
// 		case DriedCannabisSubMatrix.FLOWER:
// 			return translation("Flower");
// 		case DriedCannabisSubMatrix.INFUSED_FLOWER:
// 			return translation("InfusedFlower");

// 		case DriedCannabisSubMatrix.MILLED:
// 			return translation("Milled");

// 		case DriedCannabisSubMatrix.INFUSED_MILLED:
// 			return translation("InfusedMilled");

// 		case DriedCannabisSubMatrix.PRE_ROLL:
// 			return translation("PreRoll");

// 		case DriedCannabisSubMatrix.INFUSED_PRE_ROLL:
// 			return translation("InfusedPreRoll");

// 		case DriedCannabisSubMatrix.SHAKE:
// 			return translation("Shake");

// 		case DriedCannabisSubMatrix.TRIM:
// 			return translation("Trim");

// 		case HempSubMatrix.HEMP:
// 			return translation("Hemp");

// 		case FreshCannabisSubMatrix.FLOWER:
// 			return translation("Flower");

// 		case FreshCannabisSubMatrix.LEAF:
// 			return translation("Leaf");

// 		case FreshCannabisSubMatrix.ROOT:
// 			return translation("Root");

// 		case ConsumablesSubMatrix.CANNABIS_OIL:
// 			return translation("CannabisOil");

// 		case ConsumablesSubMatrix.SPRAYS:
// 			return translation("Sprays");

// 		case ConsumablesSubMatrix.TINCTURES:
// 			return translation("Tinctures");

// 		case ConsumablesSubMatrix.BEVERAGE:
// 			return translation("Beverage");

// 		case ConsumablesSubMatrix.EDIBLES:
// 			return translation("Edibles");
// 		case ConsumablesSubMatrix.CAPSULES:
// 			return translation("Capsules");
// 		case TopicalsSubMatrix.CREAMS:
// 			return translation("Creams");

// 		case TopicalsSubMatrix.LINIMENTS:
// 			return translation("Liniments");

// 		case TopicalsSubMatrix.SALVES:
// 			return translation("Salves");

// 		case ChemicalConcentrateExtractSubMatrix.BADDER:
// 			return translation("Badder");

// 		case ChemicalConcentrateExtractSubMatrix.LIVE_BADDER:
// 			return translation("LiveBadder");

// 		case ChemicalConcentrateExtractSubMatrix.DIAMONDS:
// 			return translation("Diamonds");

// 		case ChemicalConcentrateExtractSubMatrix.DISTILLATE:
// 			return translation("Distillate");

// 		case ChemicalConcentrateExtractSubMatrix.HASH_OIL:
// 			return translation("HashOil");

// 		case ChemicalConcentrateExtractSubMatrix.ISOLATE:
// 			return translation("Isolate");

// 		case ChemicalConcentrateExtractSubMatrix.RESIN:
// 			return translation("Resin");

// 		case ChemicalConcentrateExtractSubMatrix.LIVE_RESIN:
// 			return translation("LiveResin");

// 		case ChemicalConcentrateExtractSubMatrix.SHATTER:
// 			return translation("Shatter");

// 		case ChemicalConcentrateExtractSubMatrix.WAX:
// 			return translation("Wax");

// 		case PhysicalConcentrateExtractSubMatrix.HASH:
// 			return translation("Hash");

// 		case PhysicalConcentrateExtractSubMatrix.DRY_SIFT_HASH:
// 			return translation("DrySiftHash");

// 		case PhysicalConcentrateExtractSubMatrix.KIEF:
// 			return translation("Kief");

// 		case PhysicalConcentrateExtractSubMatrix.PRESSED_KIEF:
// 			return translation("PressedKief");

// 		case PhysicalConcentrateExtractSubMatrix.ROSIN:
// 			return translation("Rosin");

// 		case PhysicalConcentrateExtractSubMatrix.FLOWER_ROSIN:
// 			return translation("FlowerRosin");

// 		case PhysicalConcentrateExtractSubMatrix.HASH_ROSIN:
// 			return translation("HashRosin");

// 		case PhysicalConcentrateExtractSubMatrix.LIVE_ROSIN:
// 			return translation("LiveRosin");

// 		case AccessoriesSubMatrix.ROLLING_PAPER:
// 			return translation("RollingPaper");

// 		case OtherSubMatrix.SOLID:
// 			return translation("OtherSolid");

// 		case OtherSubMatrix.INHALABLE:
// 			return translation("OtherInhalable");
// 		case OtherSubMatrix.LIQUID:
// 			return translation("OtherLiquid");
// 		case DriedCannabisSubMatrix.NOT_SPECIFIED:
// 		case DriedCannabisSubMatrix.NOT_SPECIFIED:

// 		case HempSubMatrix.NOT_SPECIFIED:

// 		case FreshCannabisSubMatrix.NOT_SPECIFIED:

// 		case ConsumablesSubMatrix.NOT_SPECIFIED:

// 		case TopicalsSubMatrix.NOT_SPECIFIED:

// 		case ChemicalConcentrateExtractSubMatrix.NOT_SPECIFIED:
// 		case PhysicalConcentrateExtractSubMatrix.NOT_SPECIFIED:
// 		case AccessoriesSubMatrix.NOT_SPECIFIED:
// 		case OtherSubMatrix.NOT_SPECIFIED:
// 			return translation("NotSpecified");
// 	}
// }

export function extractInternalCodeFromFileName(
	fileName: string
): string | null {
	const regex = /--(\d+_\d+)-/;
	const match = fileName.match(regex);
	return match ? match[1] : null;
}

// export function getInitialBasicTestPerformed(): TestingOptionsBase {
// 	return {
// 		cannabinoid: false,
// 		terpene: false,
// 		pesticides: false,
// 		mycotoxins: false,
// 		heavyMetals: false,
// 		foreignMatter: false,
// 		waterActivity: false,
// 		moistureContent: false,
// 		residualSolvent: false,
// 	};
// }

// export function getInitialMicroTestPerformed(): MicroTestPerformed {
// 	return {
// 		TAMC: false,
// 		TYMC: false,
// 		BTGN: [],
// 		Salmonella: [],
// 		EColi: [],
// 		Staphylococcus: [],
// 		Pseudomonas: false,
// 		viroids: false,
// 		sexGenderTesting: false,
// 	};
// }

export function getSampleSortString(
	sortColumn: SampleSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (sortColumn) {
		case SampleSortColumn.FULL_SAMPLE_ID:
			return translation("SampleId");
		case SampleSortColumn.INSERTED:
			return translation("Createdon");
		case SampleSortColumn.SAMPLE_NAME:
			return translation("SampleName");
		case SampleSortColumn.LOT_CODE:
			return translation("LotCode");
	}
}

export function getMicroTestMethodTranslationText(
	testMethod: MicroTestMethod,
	translation: TFunction<"translation", undefined>
) {
	switch (testMethod) {
		case MicroTestMethod.NOT_SPECIFIED:
			return translation("Default");
		case MicroTestMethod.QPCR:
			return translation("qPCR");
		case MicroTestMethod.PLATE:
			return translation("PlateMethod");
	}
}

export function sortByTurnaroundItems(
	items: FrontendSampleTestInformation[]
): FrontendSampleTestInformation[] {
	const order = {
		[TurnaroundTime.STANDARD]: 1,
		[TurnaroundTime.RUSH]: 2,
		[TurnaroundTime.URGENT]: 3,
		[TurnaroundTime.SAMEDAY]: 4,
	};

	return items.sort(
		(a, b) => order[a.turnaroundTime] - order[b.turnaroundTime]
	);
}

export function getAdditionalInfoValueDisplayText(
	info:
		| FrontendSampleAdditionalInfoMapping
		| FrontendSampleInstanceAdditionalInfoMapping
): string {
	switch (info.fieldType) {
		case AdditionalInfoFieldType.TEXT:
			return info.value as string;
		case AdditionalInfoFieldType.DATE:
			return formatCustomDate(new Date(info.value), true);
	}
}
